export default {
  state: {
    nextStep: false,
    onboarding_complete: false,
    answersOfStep: {
      step1: '',
      step2: null,
      step3: null,
      step4: null,
    },
  },

  mutations: {
    SET_STEP(state, payload) {
      state.nextStep = payload
    },

    SET_ANSWER(state, payload) {
      state.answersOfStep[payload.step] = payload.answer
    },

    SET_ONBOARDING_COMPLETE(state, payload) {
      state.onboarding_complete = payload
    },
  },

  actions: {
    setStep(context, payload) {
      context.commit('SET_STEP', payload)
    },

    setAnswer(context, payload) {
      context.commit('SET_ANSWER', payload)
    },

    setOnboardingComplete(context, payload) {
      context.commit('SET_ONBOARDING_COMPLETE', payload)
    },
  },
}
